import { Button } from '@hakimo-ui/shared/ui-base';
import { PencilIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

export const FIELD_LABEL_CLASS =
  'text-onlight-text-3 dark:text-ondark-text-2 text-xs font-medium uppercase tracking-wide';

export const PANEL_TITLE_CLASS =
  'text-onlight-text-1 dark:text-ondark-text-1 text-base font-semibold';

interface Props {
  title?: string;
  titleAdornment?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Panel({
  title,
  titleAdornment,
  action,
  className = '',
  children,
}: Props) {
  return (
    <div
      className={`dark:bg-ondark-bg-1 bg-onlight-bg-1 rounded-lg p-4 ${className}`}
    >
      {(title || action) && (
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            {title && <h2 className={PANEL_TITLE_CLASS}>{title}</h2>}
            {titleAdornment}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function EditButton({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Edit ${label}`}
      className="text-onlight-text-2 dark:text-ondark-text-2 dark:hover:bg-ondark-bg-3 hover:bg-onlight-bg-2 shrink-0 rounded p-1"
    >
      <PencilIcon className="h-4 w-4" />
    </button>
  );
}

export function EditActions({
  saving = false,
  onSave,
  onCancel,
}: {
  saving?: boolean;
  onSave: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="mt-3 flex justify-end gap-2">
      <Button
        variant="primary"
        onClick={onSave}
        disabled={saving}
        loading={saving}
      >
        Update
      </Button>
      <Button onClick={onCancel}>Cancel</Button>
    </div>
  );
}

export default Panel;
